import React from 'react';
import { MiningGroupManager } from './MiningGroupManager';
import type { TokenSummary } from '../../utils/tokens';
import type { MiningConfigs, MiningGroup } from '../../types/mining';

interface MiningGroupsContainerProps {
  tokens: TokenSummary[];
  miningConfigs: MiningConfigs;
  onAddMiningGroup: (tokenId: string, group: Omit<MiningGroup, 'id'>) => void;
  onUpdateMiningGroup: (tokenId: string, groupId: string, updatedGroup: Partial<Omit<MiningGroup, 'id'>>) => void;
  onRemoveMiningGroup: (tokenId: string, groupId: string) => void;
}

export const MiningGroupsContainer: React.FC<MiningGroupsContainerProps> = ({
  tokens,
  miningConfigs,
  onAddMiningGroup,
  onUpdateMiningGroup,
  onRemoveMiningGroup,
}) => {
  if (tokens.length === 0) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-lg p-8 text-center">
        <div className="text-gray-500 dark:text-gray-400">
          <svg className="w-16 h-16 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
          <p className="text-lg font-medium">Aucune crypto-monnaie</p>
          <p className="text-sm mt-2">Ajoutez des payouts pour commencer à gérer vos groupes de minage</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {tokens.map(token => {
        const groups = miningConfigs[token.crypto.id] || [];

        return (
          <MiningGroupManager
            key={token.crypto.id}
            tokenId={token.crypto.id}
            tokenName={token.crypto.name}
            groups={groups}
            onAddGroup={(group) => onAddMiningGroup(token.crypto.id, group)}
            onUpdateGroup={(groupId, updatedGroup) => onUpdateMiningGroup(token.crypto.id, groupId, updatedGroup)}
            onRemoveGroup={(groupId) => onRemoveMiningGroup(token.crypto.id, groupId)}
          />
        );
      })}
    </div>
  );
};
